import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FaRegEdit } from "react-icons/fa";
import Swal from "sweetalert2";
import { userServices } from "../../../APIServices/UserData/userServices";

const UpdateProfileName = ({
  auth,
  setUpdator,
  currentUserData,
  Show,
  Hide,
  Title,
  isDark,
}) => {
  const [fullName, setFullName] = useState("");
  const [loader, setLoader] = useState("");

  const updateProfile = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Profile Name?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true);
        let userData = {};
        userData.fullName = fullName;
        let data = await userServices.updateProfile(auth, userData);
        if (data?.statusCode === 200) {
          setUpdator(`updateProfile_${Math.floor(10000 + Math.random() * 90000)}`);
          Hide()
          const existingList =
            JSON.parse(localStorage.getItem("accountList")) || [];
          let fianlList = existingList.map(user =>
            user.email === currentUserData?.email
              ? { ...user, name: fullName }
              : user
          );
          localStorage.setItem("accountList", JSON.stringify(fianlList));
        }
        setLoader(false);
      }
    });
  };

  useEffect(() => {
    setFullName(currentUserData?.name || "");
  }, [currentUserData]);
  return (
    <Modal show={Show} onHide={Hide} size="md">
      <Modal.Header
        closeButton
        className={`${isDark ? "bg-dark text-light" : "bg-light"} p-3 border-bottom`}
      >
        <Modal.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={`rounded-bottom ${isDark ? "bg-dark" : "bg-white"}`}>
        <Form.Group className="mb-2">
          <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
            Name
          </Form.Label>
          <Form.Control
            type="text"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            className="interactive-input rounded-1"
            style={{ fontSize: 12, padding: "6px 15px" }}
            placeholder="Enter Name"
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <div className="hstack justify-content-end">
          <Button
            disabled={!fullName || loader}
            onClick={updateProfile}
            variant="outline-primary"
            style={{ fontSize: 13 }}
            title="Update Name"
            className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
          >
            <FaRegEdit /> Update
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateProfileName;
